import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { CSP_NONCE, importProvidersFrom } from '@angular/core';
import { provideServerRendering } from '@angular/platform-server';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || '';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    { provide: CSP_NONCE, useValue: nonce },
    provideServerRendering(),
    importProvidersFrom(BrowserAnimationsModule),
    { provide: 'HYDRATION_DIAGNOSTICS', useValue: true },
  ],
}).catch((err) => console.error(err));